module.exports = __webpack_public_path__ + "img/bt-start.0d33a2dc.png";